export default __webpack_public_path__ + "static/media/fraction-editor-blue.d84002d7.svg";